import React, { Suspense } from "react";
import { AppBar, Box, Container, Drawer, Hidden, IconButton, Toolbar } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { NavigationDrawer } from "src/components/NavigationDrawer";
import { AccountMenu } from "src/components/header/AccountMenu";
import { LanguageMenu } from "src/components/header/LanguageMenu";
import { HelpMenu } from "src/components/header/HelpMenu";
import { PageLoader } from "src/components/page/loading/PageLoader";
import { Outlet } from "react-router";

interface Props {}
export function AppLayout(props: Props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const container = window !== undefined ? () => window.document.body : undefined;

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  return (
    <Styles>
      <AppBar position="fixed" color="transparent" elevation={0} className="app-bar">
        <Toolbar className="toolbar">
          <IconButton
            color="inherit"
            // edge="start"
            onClick={handleDrawerToggle}
            className="menu-button"
            size="large"
          >
            <MenuIcon />
          </IconButton>

          <Box flexGrow={1} />
          <LanguageMenu />
          <AccountMenu />
          <HelpMenu />
        </Toolbar>
      </AppBar>
      <nav className="drawer">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            className="drawer-paper"
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <NavigationDrawer />
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer className="drawer-paper" variant="permanent" open>
            <NavigationDrawer />
          </Drawer>
        </Hidden>
      </nav>

      <Container className="content" maxWidth="lg">
        <Suspense fallback={<PageLoader />}><Outlet /></Suspense>
      </Container>
    </Styles>
  );
}

const toolbarHeight = 80;

const Styles = styled("div")`
  display: flex;
  height: 100%;

  .app-bar {
    ${(props) => props.theme.breakpoints.up("sm")} {
      margin-left: ${({ theme }) => theme.navigationDrawer.width}px;
      width: calc(100% - ${({ theme }) => theme.navigationDrawer.width}px);
    }
  }

  .toolbar {
    ${({ theme }) => ({ ...theme.mixins.toolbar })}
    padding-top: ${({ theme }) => theme.spacing(1)};
    padding-bottom: ${({ theme }) => theme.spacing(3)};
  }

  .drawer {
    ${(props) => props.theme.breakpoints.up("sm")} {
      width: ${({ theme }) => theme.navigationDrawer.width}px;
      flex-shrink: 0;
    }
  }

  .page-title {
    margin-top: ${({ theme }) => theme.spacing(3)};
    align-self: flex-end;
  }

  .menu-button {
    margin-right: ${(props) => props.theme.spacing(3)};

    ${(props) => props.theme.breakpoints.up("sm")} {
      display: none;
    }
  }
  .toolbar {
    height: ${toolbarHeight}px;
  }

  .drawer-paper {
    width: ${({ theme }) => theme.navigationDrawer.width}px;
  }
  .content {
    position: relative;
    flex-grow: 1;
    overflow: auto;
    height: calc(100% - ${toolbarHeight}px);
    margin-top: ${toolbarHeight}px;
  }
`;
